export default "__VITE_ASSET__DscUcIvt__"